import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useEventNameParam = () => {
	const { eventName } = useParams<{ eventName?: string }>();
	return useMemo(() => eventName, [eventName]);
};
